module.exports = __webpack_public_path__ + "static/media/statement-ring.80769531.png";